import moment from 'moment';
import lodash from 'lodash';

export class Utils {
    public convertLowercaseWithoutSpace = (str: string) => {
        if (str && str.trim().length > 0) {
            str = str.trim().toLowerCase();
            str = str.replace(/ /g, '_');
        }
        return str;
    }

    public convertUTCtoLocal(date: any) {
        if (!date) {
            return '';
        }
        const stillUtc = moment.utc(date, 'DD/MM/YYYY HH:mm:ss').toDate();
        const local = moment(stillUtc).local();
        return local;
    }

    public convertUTCtoLocalString(date: any) {
        if (!date) {
            return '';
        }
        const stillUtc = moment.utc(date, 'YYYY-MM-DD HH:mm:ss').toDate();
        const local = moment(stillUtc).local().toDate();
        return local.toLocaleString([], { day: 'numeric', month: 'numeric', year: 'numeric' });
    }

    public convertCamelCaseToHypens(str: string) {
        return str.replace(/([A-Z])/g, (g: any) => `-${g[0].toLowerCase()}`);
    }

    /*public copy(toCopy: any, element: any) {
        const textarea = angular.element(document.querySelector('#' + element));
        textarea[0].select();
        try {
            const successful = document.execCommand('copy');
            if (!successful) {
                throw successful;
            }
        } catch (err) {
            window.prompt('Copy to clipboard: Ctrl+C, Enter', toCopy);
        }
    }*/

    public dispalyDate(date: any, time: any) {
        if (!time) {
            time = '00:00';
        }
        const day = (date.getDate()) < 10 ? `0${date.getDate()}` : date.getDate();
        const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1);
        const result = `${day}/${month}/${date.getFullYear()} ${time}:00`;
        return result;
    }

    public convertDate(date: any, time: any, _: any, flag: any) {
        let tt = moment(time);
        if (flag === 'start' && !time) {
            tt = moment().startOf('day');
        } else if (flag === 'end' && !time) {
            tt = moment().endOf('day');
        }
        const toDateTime = moment(date).set({
            hour: tt.get('hour'),
            minute: tt.get('minute'),
            second: tt.get('second')
        });
        return toDateTime.toDate();
    }

    public convertUTCtoLocalWithoutFormat(date: any) {
        if (!date) {
            return;
        }
        const stillUtc = moment.utc(date).toDate();
        const local = moment(stillUtc).local().toDate();
        return local.toLocaleString();
    }

    public setSpace = (item: string) => item.replace(/([A-Z]+)/g, ' $1');

    public validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    public isFieldEmpty(value: any) {
        return !value || value.toString().trim().length == 0;
    }

    public isEmpty = function (obj: any) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    };

    public deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return lodash.cloneDeep(obj);
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/utils/util.ts